import React from 'react';
import { TierTable } from '../styles/BillingStyledComponents';

/**
 * 구간별 요금 계산 표.
 *
 * 컬럼: 구간 | 적용 수량 | 사용 금액 | 할인 | 적용 금액
 * 푸터: 총 사용 금액 / 할인 금액 / 최종 금액
 *
 * 모든 값은 백엔드 응답값(applied_tiers, totalUsageFee/totalTierDiscount/totalAppliedFee)을
 * 그대로 표시. 프론트는 합산/판단 안 함 (totalUsageFee 누락 시에만 fallback 합산).
 *
 * 컬럼 명명은 SDK Agent 외 다른 service item 에도 재사용 가능하도록 도메인-중립화.
 */
const TierUsageTable = ({ tiers, totalTierDiscount, totalAppliedFee, totalUsageFee }) => {
    if (!tiers || tiers.length === 0) return null;

    const discountTotal = totalTierDiscount != null
        ? totalTierDiscount
        : tiers.reduce((sum, t) => sum + (t.tier_discount || 0), 0);
    const appliedTotal = totalAppliedFee != null
        ? totalAppliedFee
        : tiers.reduce((sum, t) => sum + (t.monthly_fee_for_tier || 0), 0);
    const usageTotal = totalUsageFee != null
        ? totalUsageFee
        : appliedTotal + discountTotal;

    // 적용 수량: 정수면 정수로, 소수면 유효 소수점까지만 표시 (끝자리 0 제거)
    const formatAmount = (v) => {
        const n = parseFloat(v);
        if (isNaN(n)) return v;
        return n % 1 === 0 ? String(n) : n.toString();
    };

    return (
        <div style={{ overflowX: 'auto' }}>
            <TierTable>
                <thead>
                    <tr>
                        <th>구간</th>
                        <th>적용 수량</th>
                        <th>사용 금액</th>
                        <th>할인</th>
                        <th style={{ textAlign: 'right' }}>적용 금액</th>
                    </tr>
                </thead>
                <tbody>
                    {tiers.map((tier, idx) => {
                        const usageFee = (tier.monthly_fee_for_tier || 0) + (tier.tier_discount || 0);
                        const discountUnit = tier.discount_type === 'percent' ? '%' : '원';
                        return (
                            <tr key={idx}>
                                <td style={{ fontWeight: 600 }}>
                                    {tier.agent_count_from}~{tier.agent_count_to}
                                </td>
                                <td>{formatAmount(tier.agents_in_tier)}</td>
                                <td>₩{usageFee.toLocaleString()}</td>
                                <td>
                                    {tier.discount_rate}{discountUnit}
                                </td>
                                <td style={{ textAlign: 'right', fontWeight: 600 }}>
                                    ₩{tier.monthly_fee_for_tier?.toLocaleString()}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan={4} style={{ textAlign: 'right' }}>총 사용 금액</th>
                        <th style={{ textAlign: 'right' }}>
                            ₩{usageTotal.toLocaleString()}
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={4} style={{ textAlign: 'right' }}>할인 금액</th>
                        <th style={{ textAlign: 'right', color: '#10b981' }}>
                            -₩{Math.abs(discountTotal).toLocaleString()}
                        </th>
                    </tr>
                    <tr>
                        <th colSpan={4} style={{ textAlign: 'right' }}>최종 금액</th>
                        <th style={{ textAlign: 'right', color: '#1e40af', fontSize: '1rem' }}>
                            ₩{appliedTotal.toLocaleString()}
                        </th>
                    </tr>
                </tfoot>
            </TierTable>
        </div>
    );
};

export default TierUsageTable;
